import { Component, ViewChild, signal, AfterViewInit, inject, OnInit, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule, Router } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { MenuModule } from 'primeng/menu';
import { Menu } from 'primeng/menu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { OverlayPanel } from 'primeng/overlaypanel';
import { BadgeModule } from 'primeng/badge';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '../service/layout.service';
import { AuthService } from '../../service/auth.service';
import { MessageApiService } from '../../service/messageapi.service';
import { MessageEventService } from '../../service/message-event.service';
import { LanguageSwitcherComponent } from './language-switcher.component';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil, interval } from 'rxjs';
import { ComposeDialogComponent } from '../../pages/messages/compose-dialog.component';
import { MESSAGES_ENABLED } from '../../app.feature-flags';
import { TrialChipComponent } from './trial-chip.component';
import { OtherAccountSource } from './other-account.source';
import { OrgNameStore } from '../../org/org-name.store';
import { AccountModeService } from '../../service/account-mode.service';
import { WebTokenBridge } from '../../web-auth/web-token.bridge';
import { helpRouteFor } from '../../help/help-route';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, MenuModule, OverlayPanelModule, BadgeModule, AppConfigurator, LanguageSwitcherComponent, TranslateModule, ComposeDialogComponent, TrialChipComponent],
    template: ` <div class="layout-topbar">
        <div class="layout-topbar-logo-container">
            <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
                <i class="pi pi-bars"></i>
            </button>
            <a class="layout-topbar-logo" routerLink="/">
                <img src="assets/logo.svg" alt="KarteX Logo" class="h-9 w-auto logo-theme-adaptive">
            </a>
            <!-- 2026-10-19: org panelinde giriş sonrası yalnız kurum adı (logo/tür yok) -->
            @if (orgName(); as n) {
                <span data-testid="topbar-org-name" class="ml-3 pl-3 border-l border-surface-200 dark:border-surface-700 font-semibold truncate max-w-48" [title]="n">{{ n }}</span>
            }
        </div>

        <div class="layout-topbar-actions">
            <app-trial-chip class="flex items-center" />
            <div class="layout-config-menu">
                <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                    <i [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
                </button>
                <div class="relative" #themeContainer>
                    <button
                        #themeToggle
                        class="layout-topbar-action layout-topbar-action-highlight"
                        (click)="toggleThemePanel()"
                    >
                        <i class="pi pi-palette"></i>
                    </button>
                    <app-configurator #themeConfigurator [class.hidden]="!isThemePanelVisible" class="animate-scalein" />
                </div>
                @if (helpRoute(); as route) {
                    <a class="layout-topbar-help" data-testid="topbar-help" [routerLink]="route" [attr.aria-label]="'COMMON.HELP.TITLE' | translate">
                        <i class="pi pi-question-circle"></i>
                        <span>{{ 'COMMON.HELP.TITLE' | translate }}</span>
                    </a>
                }
                <app-language-switcher />
            </div>

            <!-- Envelope button with overlay panel -->
            <!-- Removed envelope button and overlay panel -->

            <!-- Profile button with overlay panel -->
            <div class="relative">
                <button
                    class="layout-topbar-action"
                    (click)="showProfileMenu($event)"
                >
                    <i class="pi pi-user"></i>
                    <span class="notification-badge" *ngIf="messagesEnabled && unreadMessageCount > 0">{{ unreadMessageCount > 99 ? '99+' : unreadMessageCount }}</span>
                </button>
                <p-overlaypanel #profilePanel>
                    <div class="p-3">
                        <div class="flex flex-col gap-2">
                            <!-- Oturumun kimle acildigi arayuzun HICBIR yerinde gorunmuyordu;
                                 cikis dugmesiyle ayni panelde gostermek en dogal yer. -->
                            <div class="flex items-center gap-2 pb-3 mb-1 border-b border-surface-200 dark:border-surface-700" *ngIf="username">
                                <div class="w-8 h-8 bg-primary rounded-full flex items-center justify-center shrink-0">
                                    <i class="pi pi-user text-white text-sm"></i>
                                </div>
                                <div class="min-w-0">
                                    <div class="text-xs text-muted-color">{{ ('COMMON.PROFILE.SIGNED_IN_AS' | translate) }}</div>
                                    <div class="font-semibold text-sm truncate">{{ username }}</div>
                                </div>
                            </div>
                            <!--
                            <div class="flex items-center gap-2 p-2 pb-3 mb-2">
                                <div class="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                                    <i class="pi pi-user text-white text-sm"></i>
                                </div>
                                <div>
                                    <div class="font-semibold text-sm">{{ ('COMMON.PROFILE.USER_PROFILE' | translate) }}</div>
                                    <div class="text-xs text-gray-500">user&#64;example.com</div>
                                </div>
                            </div>
-->
                            <!-- Message-related menu items — Mesajlar modülü prod'a hazır değil (bkz. app.feature-flags.ts) -->
                            <ng-container *ngIf="messagesEnabled">
                                <button class="flex items-center gap-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded" (click)="onNewMessage()">
                                    <i class="pi pi-plus"></i>
                                    <span>{{ ('COMMON.PROFILE.NEW_MESSAGE' | translate) }}</span>
                                </button>
                                <button class="flex items-center gap-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded" (click)="onInbox()">
                                    <i class="pi pi-inbox"></i>
                                    <span>{{ ('COMMON.PROFILE.INBOX' | translate) }}</span>
                                    <span class="bg-red-500 text-white text-xs px-2 py-1 rounded-full" *ngIf="unreadMessageCount > 0">{{ unreadMessageCount > 99 ? '99+' : unreadMessageCount }}</span>
                                </button>
                                <button class="flex items-center gap-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded" (click)="onSent()">
                                    <i class="pi pi-send"></i>
                                    <span>{{ ('COMMON.PROFILE.SENT' | translate) }}</span>
                                </button>
                            </ng-container>
<!--
                            <button class="flex items-center gap-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded" (click)="onProfile()">
                                <i class="pi pi-user-edit"></i>
                                <span>{{ ('COMMON.PROFILE.EDIT_PROFILE' | translate) }}</span>
                            </button>
-->
                            <button class="flex items-center gap-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded" (click)="onCompanyProfile()">
                                <i class="pi pi-building"></i>
                                <span>{{ ('COMMON.PROFILE.COMPANY_PROFILE' | translate) }}</span>
                            </button>
                            <button class="flex items-center gap-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded" data-testid="menu-new-account" (click)="onNewAccount()">
                                <i class="pi pi-plus-circle"></i>
                                <span>{{ 'setup.MENU.NEW_ACCOUNT' | translate }}</span>
                            </button>
                            @if (hasOtherAccount()) {
                                <button class="flex items-center gap-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded" data-testid="menu-other-account" (click)="onOtherAccount()">
                                    <i class="pi pi-external-link"></i>
                                    <span>{{ 'setup.MENU.OTHER_ACCOUNT' | translate }}</span>
                                </button>
                            }
                            <!--
                            <button class="flex items-center gap-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded" (click)="onSettings()">
                                <i class="pi pi-cog"></i>
                                <span>{{ ('COMMON.PROFILE.SETTINGS' | translate) }}</span>
                            </button>
-->
                            <button class="flex items-center gap-2 p-2 hover:bg-red-50 dark:hover:bg-red-900 text-red-600 dark:text-red-400 rounded" (click)="onLogout()">
                                <i class="pi pi-sign-out"></i>
                                <span>{{ ('COMMON.PROFILE.LOGOUT' | translate) }}</span>
                            </button>
                        </div>
                    </div>
                </p-overlaypanel>
            </div>
        </div>
        
        <!-- Compose Dialog -->
        <app-compose-dialog
            [(visible)]="showComposeDialog"
            [replyToMessage]="null"
            (messageSent)="onMessageSent()" />
    </div>`
})
export class AppTopbar implements AfterViewInit, OnInit, OnDestroy {
    @ViewChild('profilePanel') profilePanel!: OverlayPanel;
    @ViewChild('themeContainer') themeContainer!: ElementRef;
    @ViewChild('themeConfigurator') themeConfigurator!: AppConfigurator;

    isThemePanelVisible = false;
    username: string | null = null;
    unreadMessageCount = 0;
    envelopeMenuItems: MenuItem[] = [];
    showComposeDialog = false;
    // Mesajlar modülü prod'a hazır değil — arayüzde mesaj öğeleri ve sayaç polling'i gizli/kapalı
    messagesEnabled = MESSAGES_ENABLED;

    private destroy$ = new Subject<void>();
    private messageService = inject(MessageApiService);
    private messageEventService = inject(MessageEventService);
    private authService = inject(AuthService);
    public layoutService = inject(LayoutService);
    private translateService = inject(TranslateService);
    private otherSrc = inject(OtherAccountSource);
    private location = inject(Location);
    /** Org panelindeyken kurum adı; başka yüzeyde null. */
    readonly orgName = inject(OrgNameStore).name;
    private readonly webBridge = inject(WebTokenBridge);
    private readonly accountMode = inject(AccountModeService);

    /** Yardım hedefi giriş türüne göre; görünmeyecekse null. */
    helpRoute(): string | null {
        return helpRouteFor({
            admin: this.webBridge.active() === 'admin',
            ent: this.webBridge.isEnt(),
            organization: this.accountMode.isOrganization(),
            hasAccessToken: !!this.authService.getAccessToken()
        });
    }

    constructor(private router: Router) {
        this.initializeEnvelopeMenu();
        this.username = this.authService.getUsername();
    }

    ngOnInit() {
        // Subscribe to language changes to update envelope menu
        this.translateService.onLangChange
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.initializeEnvelopeMenu();
            });

        // Mesajlar modülü kapalıysa sayaç aboneliği/polling'i başlatma (gereksiz API çağrısı yok)
        if (this.messagesEnabled) {
            // Subscribe to message events for real-time unread count updates
            this.messageEventService.unreadCount$
                .pipe(takeUntil(this.destroy$))
                .subscribe(count => {
                    this.unreadMessageCount = count;
                    this.initializeEnvelopeMenu();
                });

            // Start polling for unread message count
            this.startMessageCountPolling();
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private startMessageCountPolling() {
        // Poll every 30 seconds for unread message count
        interval(30000)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.loadUnreadMessageCount();
            });

        // Load initial count
        this.loadUnreadMessageCount();
    }

    private loadUnreadMessageCount() {
        this.messageService.getMessageStats().subscribe({
            next: (stats) => {
                this.unreadMessageCount = stats.unreadMessages || 0;
                // Refresh envelope menu with new count
                this.initializeEnvelopeMenu();
            },
            error: (error) => {
                console.error('Error loading unread message count:', error);
                this.unreadMessageCount = 0;
                this.initializeEnvelopeMenu();
            }
        });
    }

    ngAfterViewInit() {
        // Ensure the overlay panel is initialized after the view is rendered
    }

    showEnvelopeMenu(event: Event) {
        // Envelope menu functionality removed - using profile menu instead
        // This method is kept for compatibility but redirects to profile menu
        this.showProfileMenu(event);
    }

    showProfileMenu(event: Event) {
        if (this.profilePanel) {
            const wasOpen = !!this.profilePanel.overlayVisible;
            this.profilePanel.toggle(event);
            // Yalnız açılırken yenile; kapanışta gereksiz istek yok.
            if (!wasOpen) void this.refreshOtherAccount();
        }
    }

    onNewMessage() {
        this.profilePanel.hide();
        this.showComposeDialog = true;
    }

    onInbox() {
        this.profilePanel.hide();
        this.router.navigate(['/pages/messages/inbox']);
    }

    onSent() {
        this.profilePanel.hide();
        this.router.navigate(['/pages/messages/sent']);
    }

    onSettings() {
        this.profilePanel.hide();
    }

    onProfile() {
        this.profilePanel.hide();
    }

    onCompanyProfile() {
        this.profilePanel.hide();
        this.router.navigate(['/pages/company-profile']);
    }

    /** Giriş sayfası adresi; panel alt yola taşınırsa base href'e göre doğru kalır. */
    private loginUrl(queryParams?: Record<string, string>): string {
        return this.location.prepareExternalUrl(this.router.serializeUrl(this.router.createUrlTree(['/auth/login'], { queryParams })));
    }

    /** Spec 2.6 / K4: yeni hesap yeni sekmede kendi QR girişiyle (purpose=create) açılır; bu oturum kapanmaz. */
    onNewAccount() {
        this.profilePanel.hide();
        window.open(this.loginUrl({ purpose: 'create' }), '_blank', 'noopener');
    }

    /** Kullanıcının öteki türde hesabı var mı; hata ya da kaynak yoksa false (satır çizilmez, yalnız "Yeni hesap aç" kalır). */
    readonly hasOtherAccount = signal(false);
    private otherSeq = 0;
    async refreshOtherAccount(): Promise<void> {
        const seq = ++this.otherSeq; // geç gelen eski yanıt yeni sonucu ezmesin
        try {
            const v = await this.otherSrc.hasOther();
            if (seq === this.otherSeq) this.hasOtherAccount.set(v);
        } catch (e) {
            console.warn('otherAccount', e);
            if (seq === this.otherSeq) this.hasOtherAccount.set(false);
        }
    }

    /** Öteki hesap (Şirket↔Üyelik) yeni sekmede kendi QR girişiyle açılır; hesap seçici yok. Yalnız hasOtherAccount() iken görünür. */
    onOtherAccount() {
        this.profilePanel.hide();
        window.open(this.loginUrl({ go: 'login' }), '_blank', 'noopener');
    }

    /** Tüm panel yüzeylerinin çıkışı (sunucu + yerel temizlik) bitince giriş sayfasına gidilir; erken gidiş kalan oturumu geri açıyordu. */
    async onLogout(): Promise<void> {
        this.profilePanel.hide();
        try {
            await this.authService.signOutAll();
        } catch (e) {
            console.warn('[topbar] çıkış tamamlanamadı', e);
        }
        await this.router.navigate(['/auth/login']);
    }

    onMessageSent() {
        // Update unread count after message is sent
        this.loadUnreadMessageCount();
    }

    initializeEnvelopeMenu() {
        this.envelopeMenuItems = [
            {
                label: this.translateService.instant('COMMON.PROFILE.NEW_MESSAGE'),
                icon: 'pi pi-plus',
                command: () => {
                    this.showComposeDialog = true;
                }
            },
            {
                label: this.translateService.instant('COMMON.PROFILE.INBOX'),
                icon: 'pi pi-inbox',
                badge: this.unreadMessageCount > 0 ? (this.unreadMessageCount > 99 ? '99+' : this.unreadMessageCount.toString()) : undefined,
                command: () => {
                    this.router.navigate(['/pages/messages/inbox']);
                }
            },
            {
                label: this.translateService.instant('COMMON.PROFILE.SENT'),
                icon: 'pi pi-send',
                command: () => {
                    this.router.navigate(['/pages/messages/sent']);
                }
            },
            { separator: true },
            {
                label: this.translateService.instant('COMMON.PROFILE.SETTINGS'),
                icon: 'pi pi-cog',
                command: () => {
                    // Settings action
                }
            }
        ];
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }


    toggleThemePanel() {
        this.isThemePanelVisible = !this.isThemePanelVisible;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        if (this.isThemePanelVisible && this.themeContainer) {
            const target = event.target as HTMLElement;
            const isClickInsideThemeContainer = this.themeContainer.nativeElement.contains(target);

            if (!isClickInsideThemeContainer) {
                this.isThemePanelVisible = false;
            }
        }
    }
}
